import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";
import { App, Auth } from "./Constants";
import ProtectedRoute from "./protectedRoute";
import Dashboard from "../components/pages/Dashboard/index";
import PatientMaterials from "../components/pages/PatientMaterial/index";
import PatientInitiation from "../components/pages/PatientInitiation/index";
import Nurses from "../components/pages/Nurses/index";
import PAFRenew from "../components/pages/PAFRenew/index";
import NurseAdd from "../components/pages/NurseAdd/index";
import NurseEdit from "../components/pages/NurseEdit/index";
import PageNotFound from "./pageNotFound";
import ReportEvent from "../components/pages/ReportEvent";
import { registrationCategory } from "../constants/register.constants";
import ReRegister from "../components/pages/ReRegister";

import {
  verifyUserType,
  verifyUserTypeConnectedRegistrar,
} from "../shared/helpers";
import LocalStorage from "../shared/localStorage";
import Registrars from "../components/pages/Registrar";
import RegistrarAdd from "../components/pages/RegistrarAdd";
import RegistrarEdit from "../components/pages/RegistrarEdit";
import Order from "../components/pages/Order/Order";
import ContactUs from "../components/pages/ContactUs/ContactUs";
import PAFDetails from "../components/pages/PAFDetails";
import PrescriptionAuthorisationForm from "../components/pages/PAF";
import Notifications from "../components/pages/Notifications";
import ViewPatients from "../components/pages/ViewPatients";
import Profile from "../components/pages/Profile";

const Routes = ({ setLoggedInInitials }) => {
  const isPrescriber = verifyUserType(registrationCategory.PRESCRIBER);
  const isPharmacy = verifyUserType(registrationCategory.PHARMACY);
  const isConnectedNurse = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_NURSE
  );
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );

  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const isAccountExpired = !!localStorage.getItem(LocalStorage.EXPIRED_IRELAND);

  return (
    <Switch>
      {parseLocalStorage?.isLoggedIn &&
        (isPrescriber ||
          isPharmacy ||
          isConnectedNurse ||
          isConnectedRegistrar) &&
        !isAccountExpired && (
          <ProtectedRoute
            exact={true}
            path={App.DASHBOARD}
            component={Dashboard}
          />
        )}

      {(isPrescriber ||
        isPharmacy ||
        isConnectedNurse ||
        isConnectedRegistrar) &&
        !isAccountExpired && (
          <ProtectedRoute
            exact={true}
            path={App.PATIENT_MATERIALS}
            component={PatientMaterials}
          />
        )}

      {(isPrescriber || isPharmacy || isConnectedRegistrar) &&
        !isAccountExpired && (
          <ProtectedRoute
            exact={true}
            path={App.PATIENT_INITIATION}
            component={PatientInitiation}
          />
        )}
      {isPrescriber && !isAccountExpired && (
        <ProtectedRoute exact={true} path={App.NURSES} component={Nurses} />
      )}
      {isPrescriber && !isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.ADD_NURSE}
          component={NurseAdd}
        />
      )}
      {isPrescriber && !isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.EDIT_NURSE}
          component={NurseEdit}
        />
      )}

      {isPrescriber && !isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.REGISTRARS}
          component={Registrars}
        />
      )}
      {isPrescriber && !isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.ADD_REGISTRAR}
          component={RegistrarAdd}
        />
      )}
      {isPrescriber && !isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.EDIT_REGISTRAR}
          component={RegistrarEdit}
        />
      )}

      {(isPrescriber || isConnectedRegistrar) && !isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.PAF_RENEW}
          component={PAFRenew}
        />
      )}

      {(isPrescriber ||
        isPharmacy ||
        isConnectedNurse ||
        isConnectedRegistrar) &&
        !isAccountExpired && (
          <ProtectedRoute
            exact={true}
            path={App.REPORT_EVENT}
            component={ReportEvent}
          />
        )}

      {isPharmacy && !isAccountExpired && (
        <ProtectedRoute exact={true} path={App.ORDER} component={Order} />
      )}

      {isPharmacy && !isAccountExpired && (
        <ProtectedRoute exact={true} path={App.ORDER_EDIT} component={Order} />
      )}

      {(isPharmacy ||
        isPrescriber ||
        isConnectedNurse ||
        isConnectedRegistrar) &&
        localStorage.getItem(
          LocalStorage.HAS_ACCESS_TO_THE_RE_REGISTER_IRELAND
        ) && (
          <ProtectedRoute
            exact={true}
            path={App.RE_REGISTER}
            component={ReRegister}
          />
        )}

      {!isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.CONTACT_US}
          component={ContactUs}
        />
      )}

      {!isAccountExpired && isPharmacy && (
        <ProtectedRoute
          exact={true}
          path={App.PRESCRIPTION_AUTHORISATION_FORM_DETAILS}
          component={PAFDetails}
        />
      )}

      {!isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.PRESCRIPTION_AUTHORISATION_FORM}
          component={PrescriptionAuthorisationForm}
        />
      )}

      {!isAccountExpired && !isConnectedNurse && (
        <ProtectedRoute
          exact={true}
          path={App.NOTIFICATIONS}
          component={Notifications}
        />
      )}

      {!isAccountExpired && (
        <ProtectedRoute
          exact={true}
          path={App.VIEW_PATIENTS}
          component={ViewPatients}
        />
      )}

      {!isAccountExpired && (
        <ProtectedRoute path={App.PROFILE_ID}>
          <Profile setLoggedInInitials={setLoggedInInitials} />
        </ProtectedRoute>
      )}

      <Route path="/404" component={PageNotFound} />

      {isAccountExpired ? (
        <Redirect to={App.RE_REGISTER} />
      ) : (
        <Redirect to={Auth.LOGIN} />
      )}
    </Switch>
  );
};
export default Routes;
